import { IIncomeCategoryFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';

export const createNewExtendedProductIncome = (
  formValues: IIncomeCategoryFormValues,
  sequence: number
) => {
  return {
    incomeCategory: {
      nameTh: formValues.nameTh,
      nameEn: formValues.nameEn,
      subGroup: INCOME_SUBGROUP_CATEGORY.PRODUCT_INCOME,
      sequence: sequence,
    },
  };
};
